/** Thrown by {@link parse} when the input is structurally invalid. */
export class RouteParseError extends Error {
  /** The offending URL/path. */
  readonly path: string;

  constructor(message: string, path: string) {
    super(message);
    this.name = 'RouteParseError';
    this.path = path;

    // Restore the prototype chain — required when extending built-ins such as
    // Error while compiling to ES5/ES2015 targets (see TypeScript FAQ).
    Object.setPrototypeOf(this, RouteParseError.prototype);
  }
}
